import type { BaseSyntheticEvent } from "react"
import React, { useCallback, useEffect, useRef, useState } from "react"
import CustomScroll from "react-custom-scroll"

import { useWindowSize } from "components/hooks/use-window-size"

import { Box } from "components/shared/box"
import GradientDivider from "components/shared/game/gradiend-divider"

type ScrollableContentProps = {
  children: React.ReactNode
  className?: string
  showTopBorder?: boolean
  showBottomShadow?: boolean
}
export function ScrollableContent({
  children,
  className = "",
  showTopBorder,
  showBottomShadow,
}: ScrollableContentProps) {
  const [visibleTopBorder, setVisibleTopBorder] = useState(false)
  const [visibleBottomShadow, setVisibleBottomShadow] = useState(false)
  const scrollContentRef = useRef<never>(null)
  const size = useWindowSize()

  useEffect(() => {
    const customScrollComponent = scrollContentRef?.current as { hasScroll: boolean } | null

    setVisibleBottomShadow(!!customScrollComponent?.hasScroll)
  }, [size, children])

  const handleScroll = useCallback((e: BaseSyntheticEvent) => {
    const isTop = e.target.scrollTop === 0
    const isBottom = Math.abs(e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight) <= 1

    setVisibleTopBorder(!isTop)
    setVisibleBottomShadow(!isBottom)
  }, [])

  return (
    <div className="relative h-full flex">
      <CustomScroll flex="1" className={className} ref={scrollContentRef} onScroll={handleScroll}>
        {children}
      </CustomScroll>
      {showTopBorder && visibleTopBorder && (
        <GradientDivider orientation="horizontal" className="absolute left-0 top-0 right-0" />
      )}
      {showBottomShadow && visibleBottomShadow && (
        <Box className="w-full pointer-events-none absolute left-0 bottom-0 right-0 h-[2.4rem] bg-gradient-radial from-[#00000099] bg-[length:100%_5rem]" />
      )}
    </div>
  )
}
